<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <!--<ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Dashboard</router-link>
          </li>
        </ul>-->
      </nav>
      <div class="copyright">
        &copy; Desarrollado por
        <i class="fa fa-heart heart"></i>
        <a href="https://ceesa.com" target="_blank">CEESA, S.A.</a><i class="fa fa-heart heart"></i>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
